import { REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "./ui/input-otp";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";

interface MfaProps {
  isOpen: boolean;
  onOtpComplete: (secret: string) => void;
  onClose: () => void;
}

export function Mfa({ isOpen, onOtpComplete, onClose }: MfaProps) {
  return (
    <Sheet
      open={isOpen}
      onOpenChange={() => {
        onClose();
      }}
    >
      <SheetContent
        side="right"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginRight: "60px",
        }}
      >
        <SheetHeader>
          <SheetTitle>Multi-Factor Authentication</SheetTitle>
        </SheetHeader>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              marginBottom: "10px",
            }}
          >
            Please enter the code from your authenticator app.
          </div>
          <InputOTP
            maxLength={6}
            pattern={REGEXP_ONLY_DIGITS_AND_CHARS}
            onComplete={async (value) => {
              onOtpComplete(value);
            }}
          >
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        </div>
      </SheetContent>
    </Sheet>
  );
}
